import React from 'react';
import { MobileGuestMenu } from '../MobileGuestMenu';
import { MobileLoggedInMenu } from '../MobileLoggedInMenu';
import { useMobileViewContext } from '../../MobileView.provider';
import { IdentityWidgetContent } from '../../../IdentityWidget/components/IdentityWidgetContent';
import { useEventMemberships } from '@shared/components/AuthProvider';

export const MobileMainMenu: React.FC = () => {
  const { currentUser, eventId, onSwitchEventClick } = useMobileViewContext();
  const { eventMemberships } = useEventMemberships();
  return (
    <>
      {currentUser.profile && (
        <>
          <IdentityWidgetContent
            eventId={eventId}
            eventMemberships={eventMemberships}
            profile={currentUser.profile}
            onSwitchEventClick={onSwitchEventClick}
          />
          <MobileLoggedInMenu />
        </>
      )}
      {!currentUser.profile && <MobileGuestMenu />}
    </>
  );
};
